import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { EnvelopeSimple, ShieldCheck } from "@phosphor-icons/react";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { BrandMark, Button, Card, Input, Label } from "../components/ui-kit";

export default function VerifyContact() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const channel = "email";
  const [code, setCode] = useState("");
  const [sending, setSending] = useState(false);
  const [confirming, setConfirming] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/auth/verification/send", { channel });
      toast.success("Code envoye par email");
      if (data.dev_code) setCode(data.dev_code);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  const confirm = async (e) => {
    e.preventDefault();
    setConfirming(true);
    try {
      await api.post("/auth/verification/confirm", { channel, code });
      await refresh();
      toast.success("Compte verifie");
      if (user?.role === "driver") navigate("/driver", { replace: true });
      else if (user?.role === "courier") navigate("/courier", { replace: true });
      else if (user?.role === "merchant") navigate("/merchant", { replace: true });
      else if (user?.role === "agent") navigate("/agent", { replace: true });
      else navigate("/app", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setConfirming(false);
    }
  };

  return (
    <div className="relative app-screen bg-premium-grad grain text-foreground">
      <div className="mx-auto flex app-screen max-w-md flex-col items-center justify-center px-5 auth-screen-safe">
        <div className="mb-8"><BrandMark /></div>
        <Card className="w-full p-6">
          <div className="mb-5 flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/15 text-primary">
              <ShieldCheck size={24} weight="duotone" />
            </div>
            <div>
              <h1 className="font-heading text-2xl font-bold">Verifier le compte</h1>
              <div className="text-xs text-muted-foreground">Verification par email</div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 rounded-full border border-white/10 bg-primary px-4 py-3 text-xs font-bold uppercase tracking-widest text-primary-foreground">
            <EnvelopeSimple size={14} weight="bold" /> Email
          </div>

          <div className="mt-4 rounded-2xl bg-white/5 p-3 text-xs text-muted-foreground">
            {user?.email}
          </div>

          <Button onClick={send} disabled={sending} className="mt-4 w-full">
            {sending ? "Envoi..." : "Envoyer le code"}
          </Button>

          <form onSubmit={confirm} className="mt-4 space-y-3">
            <div>
              <Label>Code de verification</Label>
              <Input value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" required />
            </div>
            <Button type="submit" variant="secondary" disabled={confirming || !code} className="w-full">
              {confirming ? "Verification..." : "Confirmer"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
